import { Hero } from "@/components/home/Hero";
import { StatsBar } from "@/components/home/StatsBar";
import { About } from "@/components/home/About";
import { WhyChoose } from "@/components/home/WhyChoose";
import { WhoWeWork } from "@/components/home/WhoWeWork";
import { Process } from "@/components/home/Process";
import { ProjectsShowcase } from "@/components/home/ProjectsShowcase";
import { Advantages } from "@/components/home/Advantages";
import { Testimonials } from "@/components/home/Testimonials";
import { Faq } from "@/components/home/Faq";
import { CtaBand } from "@/components/home/CtaBand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <StatsBar />
      <About />
      <WhyChoose />
      <WhoWeWork />
      <Process />
      <ProjectsShowcase />
      <Advantages />
      <Testimonials />
      <Faq />
      <CtaBand />
    </div>
  );
}
